query getUserImages($input: GetUserImagesInput!) {
  userImages: getUserImages(input: $input) {
    images {
      id
      fileId
      url
      originalImageUrl
      history {
        id
        type
        timestamp
        userId
      }
    }
    total
    page
    perPage
  }
}
